<template>
  <div
    class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8"
  >
    <div class="max-w-md w-full space-y-8">
      <div>
        <img
          class="mx-auto h-12 w-auto"
          src="@/assets/logo.svg"
          alt="Workflow"
        />
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Register your account
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          Or
          <a
            @click="goToSignIn()"
            class="font-medium text-indigo-600 hover:text-indigo-500 cursor-pointer"
          >
            login to your existing account
          </a>
        </p>
      </div>
                <div class="rounded-md bg-red-050 p-4 mt-3" v-if="error">
            <div class="flex">
              <div class="flex-shrink-0">
                <!-- Heroicon name: solid/x-circle -->
                <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                  <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
              </div>
              <div class="ml-3">
                <h3 class="text-sm font-medium text-red-800">
                  There were errors with your submission
                </h3>
                <div class="mt-2 text-sm text-red-700">
                  <ul class="list-disc pl-5 space-y-1">
                    <li>
                      {{error.message}}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
      <div class="mt-8 space-y-6">
        <div>
          <label class="block text-sm font-medium text-gray-700">
            User type
          </label>
          <div class="mt-1">
            <select class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" v-model="type">
              <option v-for="type in types" :selected="type === type" :key="type">{{ type }}</option>
            </select>
          </div>
        </div>
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700">
            Email address
          </label>
          <div class="mt-1">
            <input
              id="email"
              name="email"
              type="email"
              autocomplete="email"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="email"
            />
          </div>
        </div>

        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">
            Password
          </label>
          <div class="mt-1">
            <input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="password"
            />
          </div>
        </div>
        <div>
          <label for="password" class="block text-sm font-medium text-gray-700">
            Password
          </label>
          <div class="mt-1">
            <input
              id="password"
              name="password"
              type="password"
              autocomplete="current-password"
              required
              class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              v-model="password"
            />
          </div>
        </div>

        <div>
          <button
            :class="isComplete ? 
            'group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500':
            'group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-gray-200 focus:outline-none cursor-default'"
            @click="register()"
          >
            Register
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "Register",
  data() {
    return {
      name: "",
      email: "",
      password: "",
      type: "",
      types: ["admin", "cleaner", "customer"],
      error: null
    };
  },
  components: {},
  computed: {
    isComplete() {
      return this.email == "" ? false : true;
    },
  },
  methods: {
    goToSignIn() {
      this.$router.push("/join/login");
    },
    register() {
      if(
        this.password.length < 3 ||
        this.email.length < 3
      ){
        this.error = {
          type: 'validation',
          message: 'Please make sure your email, first name and lastname are longer than 3 characters. Your phone number must be at least 8 characters.'
        }
        return
      }
      this.$store.dispatch("user/registerUser", {
        email: this.email,
        password: this.password,
        type: this.type
      });
    },
  },
};
</script>

<style>
</style>

<style></style>